import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ErrorPage.css';
import axios from 'axios';

const ErrorPage = () => {
  const navigate = useNavigate();

  const handleHomeRedirect = async() => {
    navigate('https://sfcqa.austeresystems.com/')
  };

  return (
    <Container fluid className="error-page">
      <Row className="justify-content-center align-items-center vh-100 text-center">
        <Col md={8}>
          <h1 className="display-1 text-danger">Oops!</h1>
          <h2 className="mb-4">Something went wrong...</h2>
          <p className="lead mb-5">
            We couldn't process your request. Please try again later, or return to the homepage.
          </p>
          <Button variant="primary" size="lg" onClick={handleHomeRedirect}>
            Back to Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorPage;
